<template>
  <div class="mx-auto">
    <template v-if="kc.use_hold_tap_icons">
      <Icon v-if="variant == 'tap'" icon="mdi:arrow-up-down" />
      <Icon v-else icon="mdi:arrow-collapse-down" />
    </template>

    <template v-else>
      <span v-if="variant == 'tap'" class="font-bold">T</span>
      <span v-else class="font-bold">H</span>
    </template>
  </div>
  <KeyCodes
    v-if="isKeyCode(action) || isMultipleKeyCodes(action)"
    :action="action"
    :max_length="5"
    :max_lines="1"
    :size_adjust="1"
  />
  <LayerAction
    class="scale-[70%]"
    v-else-if="isLayer(action) || isDefaultLayer(action)"
    :layer="isLayer(action) ? action.Layer : action.DefaultLayer"
    :bgColor="bgColor"
    :textColor="textColor"
    :isDefault="isDefaultLayer(action)"
  />
  <span v-else-if="isNoOp(action)"></span>
  <!-- Trans action should never happen here -->
  <span v-else-if="isTrans(action)">TRANS</span>
  <span v-else>…</span>
</template>

<script setup lang="ts">
import {
  ActionInternalNested,
  isNoOp,
  isTrans,
  isKeyCode,
  isMultipleKeyCodes,
  isLayer,
  isDefaultLayer,
} from "@/keyboard";
import { useKeycapStore } from "@/stores";
import KeyCodes from "@/components/keys/KeyCodes.vue";
import LayerAction from "@/components/keys/LayerAction.vue";

defineProps<{
  action: ActionInternalNested;
  variant: "hold" | "tap";
  bgColor: string;
  textColor: string;
}>();

const kc = useKeycapStore();
</script>
